export enum GACategories {
  gettingStarted = "Getting started"
}
